import { Injectable } from "@angular/core";
import { environment, magicLink } from "environments/environment";
import { Magic } from "magic-sdk";
import { from, Observable } from "rxjs";
import { eNetworkName } from "app/services/contract/contract.config";
const Web3 = require('web3');

@Injectable({
    providedIn: 'root'
})

export class MagicWrapperService {

    network: eNetworkName;

    constructor() {
        let network: string = localStorage.getItem('magicNetwork');
        let _network: eNetworkName = (<any>eNetworkName)[network];
        this.network = _network ? _network : environment.allowedNetwork[0];
    }

    loginWithEmailOTP(email: string) {
        return from(magicLink(this.network).auth.loginWithEmailOTP({ email }));
    }

    isLoggedIn() {
        return from(magicLink(this.network).user.isLoggedIn());
    }

    // getWeb3Magic() {
    //     let currentWeb3: any;
    //     if (this.magicLink().rpcProvider) {
    //         currentWeb3 = new window.Web3(this.magicLink().rpcProvider);
    //         return /* from( */currentWeb3/* ) */;
    //         /* try {
    //             console.log("1")
    //             // Request account access if needed

    //             this.magicLink().rpcProvider.enable()
    //             window.web3 = currentWeb3
    //             console.log(window.web3)
    //             // Acccounts now exposed
    //             return currentWeb3;
    //         } catch (error) {
    //             console.log(error)
    //             // User denied account access...
    //             return "denied_access";
    //             alert('Please allow access for the app to work');
    //         }
    //     } else {
    //         console.log("2")
    //         window.web3 = new window.Web3(this.magicLink().rpcProvider);
    //         // Acccounts always exposed
    //         return currentWeb3;*/
    //     }
    // }

    getWeb3Magic() {
        let currentWeb3: any;
        if (magicLink(this.network).rpcProvider) {
            currentWeb3 = new Web3(magicLink(this.network).rpcProvider);
            // return currentWeb3;
            try {
                // Request account access if needed
                magicLink(this.network).rpcProvider.enable();
                // window.web3 = currentWeb3;//????TODO web3 or Web3?
                // Accounts now exposed
                return currentWeb3;
            } catch (error) {
                // User denied account access...
                alert('Please allow access for the app to work');
                return "denied_access";
            }
        } else {
            // window.web3 = new Web3(magicLink().rpcProvider);//????TODO web3 or Web3?
            // return currentWeb3;
            return null;
        }
    }


    disconnectProviderMagic(): Observable<any> {
        return from(magicLink(this.network).user.logout());
    }
}
